<template>
	<div>
		<!-- 列设置 -->
		<!--  -->
		<el-dialog :show-close="show_closer" :title="dialogname" :visible.sync="show"
			:close-on-click-modal="close_modal" :close-on-press-escape="close_press" :width="width"
			:lock-scroll="lock_scrol" :before-close="handleClose" :append-to-body="true">
			
			<div class="lset_content">
				<div class="lset_head FlexBetween">
					<div></div>
					<div class="lset_btns Flexalign">
						<div class="btns FlexRow" @click="lsetClick(1)">
							恢复默认
						</div>
						<div class="btns FlexRow" @click="lsetClick(2)">
							全部显示
						</div>
						<div  class="btns FlexRow" title="勾选一条数据进行移动">
							<el-popover trigger="click" placement="bottom" >
								<template slot="reference">
									<div >
										移到
									</div>
								</template>
								<div class="movedbox FlexBetween" :class="{'isdisabled': check_list.length != 1}">
									<div class="moveinput Flexalign">
										移动到第
										<el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="moverow" clearable maxlength="3">
										</el-input>
										行
									</div>
									<div class="customBtn FlexRow" @click="movererve">
										确定
									</div>
								</div>
							</el-popover>
						</div>
						<div class="btns FlexRow"  @click="lsetClick(4)"
						:class="{'isdisabled': check_list.length != 1}">
							上移
						</div>
						<div class="btns FlexRow"  @click="lsetClick(5)"
						:class="{'isdisabled': check_list.length != 1}">
							下移
						</div>
					</div>
				</div>
				
				<div class="lset_table">
					
					<tabcontainer
					ref="tabrefconta"
					:stripe="true"
					:rowstyle="rowstyle"
					:botshow="false"
					:surplus="350"  :list.sync="tablelist"
						@retucheck="(e)=>{check_list = e.val}" >
						<!-- 表格内容 -->
						<template slot="body">
							<!--  -->
							<el-table-column align="center" type="selection"  width="50"></el-table-column>
							<!--  -->
							<el-table-column show-overflow-tooltip
							 :width="item.width"
							 :prop="item.prop" :label="item.name" v-for="(item, index) in tableColumn">
								<template v-slot="scope" v-if="index == 0"  >
									{{scope.$index + 1}}
								</template>
								<template v-slot="scope" v-else-if="index == 2"  >
									<!-- 显示列 -->
									<span>
										<el-switch
										:disabled="scope.row.disabled"
										  v-model="scope.row.show"
										  active-color="rgba(43, 117, 235, 1)">
										</el-switch>
									</span>
								</template>
							</el-table-column>
							<!--  -->
						</template>
						<!--  -->
						
					</tabcontainer>
					<!--  -->
					
				</div>
			
			</div>
			
			<div class="lset_footer FlexBetween" >
				<div></div>
				<div class="btnbox Flexalign"> 
					<div class="customBtn FlexRow" @click="preserve">
						保存
					</div>
					<div class="customBtn style2 FlexRow" @click="handleClose">
						取消
					</div>
				</div>
			</div>
		</el-dialog>
		<!--  -->




	</div>
</template>

<script>
	var that;
	var clickflag = true
	var clickTimer = null
	// 表格
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	import {
		handlereq,
		alertMess,
		get_member,
		clickgate,
	} from 'network/kh_public'
	
	import {
		// 订单配置 
		set_order_config,
	} from 'network/hk_order'
	
	//
	import {
		set_quotation_config,
		
	} from 'network/hk_quotation'
	
	export default {
		name: "columnset",
		components: {
			tabcontainer,
		},
		props: {
			groups: {  // 分组： 1：订单， 2：报价单
				type: Number,
				default: 1,
			},
			types: {
				type: Number,
				default: 1,
			},
			// 是否显示弹窗
			show: {
				type: Boolean,
				default: false,
			},
			
			columnlist: {
				type: Array,
				default: ()=>{
					return []
				}
			},
			defaultColumn: {
				type: Array,
				default: ()=>{
					return []
				}
			},
			
			
			
			// 是否显示关闭按钮
			show_closer: {
				type: Boolean,
				default: true,
			},
			// 是否可以通过点击 modal 遮罩层 关闭 Dialog
			close_modal: {
				type: Boolean,
				default: false,
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			close_press: {
				type: Boolean,
				default: true,
			},
			// 是否在 Dialog 出现时将 body 滚动锁定 
			lock_scrol: {
				type: Boolean,
				default: false,
			},
			
			width: {
				type: String,
				default: '910px',
			},
			// 
			dialogname: {
				type: String,
				default: '列设置',
			},
			
			
		},

		watch: {
			show() {
				this.current_id = 1
				this.moverow = ''
				if(this.show) {
					this.fn_initial()
				}
			},
		},
		data() {
			return {
				current_id: 1,
				
				
				moverow: '',
			
				
				rowstyle: {
					height: '42px',
				},
				// 默认列表
				defaultlist: [],
				// 表格显示列表
				tablelist: [],
				// 多选表格数据
				check_list: [],
				// 表头
				tableColumn: [
					{
						name: '序号',
					},
					{
						width: 600,
						prop: 'name',
						name: '列名',
					},
					{
						name: '显示列',
					},
				],
				// 
				
				localOrderConfig: '',
			}
		},

		created() {
			that = this
			
		},
		methods: {
			preserve(){
				this.setOrderConfig()
			},
			// 获取订单自定义
			getCustomFeatures(){
				let member_id = localStorage.member_id;
				get_member(member_id).then(res=>{
					if(handlereq(res)) {
						// 用户功能自定义 参数
						if(this.groups == 1) {
							let order_config = res.result.order_config || '';
							localStorage.setItem('order_config', order_config);
						}
						else if(this.groups == 2){
							let quotation_config = res.result.quotation_config || '';
							localStorage.setItem('quotation_config', quotation_config);
						}
						this.$emit('success')
					}
				})
			},
			fn_initial(){
				// 获取列设置 
				let localstr = '';
				if(this.groups == 1) {
					localstr = localStorage.order_config || '';
				}
				else if(this.groups == 2){
					localstr = localStorage.quotation_config || '';
				}
				
				if(localstr && typeof(localstr) == 'string') {
					let Jsres = JSON.parse(localstr)
					this.localOrderConfig = Jsres
				}
				// 设置列表
				if(this.columnlist && this.columnlist.length) {
					let arr = this.columnlist.filter(v=>v.prop)
					for(let item of arr) {
						if(item.id == undefined) {  // 没有自定义过的数据
							item.id = this.current_id
							this.current_id += 1
						}
						if(item.show == undefined) {  // 没有自定义过的数据
							item.show = true
						}
					}
					
					this.tablelist = JSON.parse(JSON.stringify(arr))
				}
				
				if(this.defaultColumn && this.defaultColumn.length) {
					let arr = this.defaultColumn.filter(v=>v.prop)
					
					for(let item of arr) {
						if(item.id == undefined) {  // 没有自定义过的数据
							item.id = this.current_id
							this.current_id += 1
							if(item.show == undefined) {  // 没有自定义过的数据
								item.show = true
							}
						}
					}
					this.defaultlist = JSON.parse(JSON.stringify(arr))
				}
			},
			// 订单配置 自定义 表格表头
			setOrderConfig(){
				if(this.groups == 1) {
					let order_config = {
						orderlist: '',
						product: '',
					}
					if(this.localOrderConfig) {
						order_config = this.localOrderConfig
					}
					if(this.types == 1) {
						order_config.orderlist = this.tablelist
					}
					else if(this.types == 2) {
						order_config.product = this.tablelist
					} 
					
					let data = JSON.stringify(order_config)
					set_order_config(data).then(res => {
						if(handlereq(res)) {
							alertMess('设置成功')
							this.handleClose()
							this.getCustomFeatures()
							
						}
					})
					
					
				}
				else if(this.groups == 2) {
					let quotation_config = {
						quotationlist: '',
						product: '',
					}
					if(this.localOrderConfig) {
						quotation_config = this.localOrderConfig
					}
					if(this.types == 1) {
						quotation_config.quotationlist = this.tablelist
					}
					else if(this.types == 2) {
						quotation_config.product = this.tablelist
					} 
					
					let data = JSON.stringify(quotation_config)
					set_quotation_config(data).then(res => {
						if(handlereq(res)) {
							alertMess('设置成功')
							this.handleClose()
							this.getCustomFeatures()
						}
					})
				}
				
				
				
				 //  
			},
			// 调换位置
			moredatas(moveIndex){
				if(this.check_list.length == 1) {
					let obj = this.check_list[0]
					let index = this.tablelist.findIndex(v=>v.id == obj.id)
					if(index != -1 && this.tablelist[index]) {
						
						var temp = ''
						temp = this.tablelist[index] 
						this.tablelist[index] = this.tablelist[moveIndex] 
						this.tablelist[moveIndex] = temp 
						
						this.moverow = ''
						this.check_list = []
						if(this.$refs.tabrefconta) {
							this.$refs.tabrefconta.fnclearSel()
						}
					}
				}
			},
			// 移动到第几行
			movererve(){
				if(clickgate()) {
					if(this.moverow && this.tablelist.length >= this.moverow) {
						let n = (this.moverow * 1) - 1
						this.moredatas(n)
					}
					else {
						alertMess('请输入有效数值','error')
					}
				}
			},
			// 
			lsetClick(flag){
				if(clickgate()) {
					let moveIndex = 0
					let arr = this.check_list
					if(arr.length) {
						let obj = this.check_list[0]
						moveIndex = this.tablelist.findIndex(v=>v.id == obj.id)
					}
					
					
					if(flag == 1) {  // 恢复默认
						this.tablelist = JSON.parse(JSON.stringify(this.defaultlist))
						alertMess('已恢复默认')
					}
					else if(flag == 2) {  // 全部显示
						for(let item of this.tablelist) {
							item.show = true
						}
						alertMess('已全部显示')
					}
					else if(flag == 4 && arr.length == 1) {  // 上移
						moveIndex -= 1
						if(moveIndex < 0) {
							moveIndex = this.tablelist.length - 1
						}
						this.moredatas(moveIndex)
					}
					else if(flag == 5 && arr.length == 1) {  // 下移
						moveIndex += 1
						if(moveIndex == this.tablelist.length) {
							moveIndex = 0
						}
						this.moredatas(moveIndex)
					}
				}
				
				
			},
			
			
			
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				this.$emit('update:show', false)
			},
		}
	}
</script>

<style scoped lang="scss">
	.movedbox{
		padding: 8px ;
		.moveinput{
			color:#3f3f3f;
			margin-right: 20px;
			
			/deep/ .el-input{
				width: 70px;
				margin: 0 5px;
			}
		}
		
	}
	.lset_content{
		// border:solid 1px red;
		.lset_head{
			margin-bottom: 20px;
			width: 100%;
			.lset_btns{
				/deep/ .el-button{
					background: none;
					border: none;
					position: relative;
					padding: 0 20px;
					font-size: 14px;
					font-weight: 400;
					color: rgba(43, 117, 235, 1);
					text-align: left;
					vertical-align: top;
				}
				/deep/ .el-button::before{
					position: absolute;
					content: '';
					display:block;
					right: 0;
					width: 1px;
					height: 15px;
					background: rgba(178, 178, 178, 1);
				}
				.btns:last-of-type::before{
					display: none;
				}
				
				.btns::before{
					position: absolute;
					content: '';
					display:block;
					right: 0;
					width: 1px;
					height: 15px;
					background: rgba(178, 178, 178, 1);
				}
				.btns{
					position: relative;
					padding: 0 20px;
					cursor: pointer;
					font-size: 14px;
					font-weight: 400;
					color: rgba(43, 117, 235, 1);
					text-align: left;
					vertical-align: top;
				}
			}
		}
	}
	
	.lset_table{
		margin-bottom: 20px;
	}
	
	.lset_footer{
		width: 100%;
		.btnbox{
			.btns{
				cursor: pointer;
				padding: 0 20px;
				min-width: 85px;
				height: 36px;
				color: #fff;
				border-radius: 2px;
				background: rgba(42, 117, 234, 1);
				margin-left: 5px;
			}
			.btns.style2{
				color: #333;
				background:#fff;
				border: 1px solid rgba(220, 223, 230, 1);       
			}
		} 
	}
</style>
